module.exports = __webpack_public_path__ + "static/media/task_detail_header_bg.34da0bf7.png";